// extracted by mini-css-extract-plugin
module.exports = {"boxes":"style_boxes__2y9zI","box":"style_box__1jWnM","title":"style_title__24QjX","content":"style_content__XvEPm"};